import React from "react";

const CocoSad = () => (
  <svg width="112" height="88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <path
        d="M22.684 65.59c0 12.187-.985 26.89 4.241 39.267 4.502 10.654 8.99 13.471 21.96 11.926 12.764-1.518 19.208-10.463 17.32-13.991-.397-.753-4.173-18.724-4.775-36.955-.315-9.506-38.746-.246-38.746-.246Z"
        fill="url(#b)"
      />
      <path
        d="M51.934 18.515c-5.322 14.333-17.635 4.841-17.635 4.841.109-.56.232-1.299.383-2.188-3.16-2.038-5.788-3.72-7.936-5.21-6.703-4.637-8.892-7.564-8.892-14.416 0-1.163 1.505-.301 3.72 1.586 3.859 3.296 9.879 9.78 13.805 14.087.069-.328.137-.642.206-.984l.027-.11c1.71-8.069 5.568-19.23 16.13-20.747.958.71-.697 3.952-3.037 7.604-3.489 5.43-8.469 11.735-8.469 11.735S57.23 4.168 51.934 18.515Z"
        fill="url(#c)"
      />
      <path
        d="M61.883 68.34c-2.558 1.75-3.27 3.077-1.655 8.657 1.614 5.58 4.063 26.601 7.073 29.296 3.01 2.694 13.681 11.037 10.85-7.18-2.833-18.218-16.268-30.774-16.268-30.774Z"
        fill="url(#d)"
      />
      <path
        d="M41.916 20.553c7.019-3.228 8.017-3.05 9.29-3.064 8.77-.013 20.795 2.435 23.888 8.945 1.587 4.076-.452 11.57-1.78 19.065-1.039 5.895-3.091 15.305-4.801 19.627-2.9 7.29-6.827 8.26-15.83 8.206-7.018.916-17.375-1.833-17.457-2.243-.082-.41 6.69-50.536 6.69-50.536Z"
        fill="url(#e)"
      />
      <path
        d="m67.29 34.517-2.286 25.726c-.41 3.734-2.23 7.18-5.103 9.683-2.23 1.942-5.007 3.187-7.976 3.597l-1.478.192a88.154 88.154 0 0 1-18.21.67 15.548 15.548 0 0 1-4.036-.807c-4.597-1.641-8.167-5.252-9.659-9.806a14.979 14.979 0 0 1-.656-2.913l-.37-2.08-1.683-9.163-2.12-11.447v-.028l-.547-2.886c-1.642-11.447 4.596-16.603 17.21-17.055l8.223-.3 10.973-.397c13.941-.137 19.427.875 17.717 17.014Z"
        fill="url(#f)"
      />
      <path
        d="M38.603 17.886c-6.718 1.04-14.516.861-20.057 4.718-7.84 5.102-4.912 14.99-4.843 15.537l-.534-2.886c-1.915-12.61 2.64-16.467 17.212-17.055l8.222-.314Z"
        fill="url(#g)"
      />
      <path
        d="M60.35 54.852c3.224-1.396 5.005-4.45 3.978-6.82-1.027-2.37-4.473-3.16-7.697-1.764-3.224 1.396-5.005 4.45-3.978 6.82 1.027 2.37 4.473 3.16 7.697 1.764ZM24.211 54.8c-.958 2.202-3.981 3.036-6.977 2.037l-1.697-9.396a7.602 7.602 0 0 1 4.693.534c3.215 1.409 5.007 4.459 3.981 6.825Z"
        fill="#5587F9"
      />
      <path
        d="M28.195 73.4c-4.597-1.682-8.783-5.06-9.659-10.066.123-7.823.93-22.854.93-22.854l7.074-1.163c-.164 9.82 1.04 26.356 1.655 34.083Z"
        fill="url(#h)"
      />
      <path
        d="M59.961 69.748a15.042 15.042 0 0 1-7.976 3.693l-1.478.205c-.971-14.128-.3-35.929-.3-35.929l8.345-1.422c.219 3.187.999 23.155 1.41 33.453Z"
        fill="url(#i)"
      />
      <path
        d="M17.605 34.462c.916-.602 1.82-1.15 2.668-1.75.82-.562 1.573-1.218 2.23-1.97a6.797 6.797 0 0 0 1.354-2.366 8.477 8.477 0 0 0 .383-2.681v-.041a1.375 1.375 0 0 1 1.45-1.286 1.383 1.383 0 0 1 1.287 1.286 9.393 9.393 0 0 1-.767 3.61 8.829 8.829 0 0 1-2.175 2.982 12.787 12.787 0 0 1-2.9 1.901c-1.013.493-2.039.876-3.024 1.272a.526.526 0 0 1-.698-.314.54.54 0 0 1 .192-.643ZM48.932 23.398a6.826 6.826 0 0 0 2.107 2.434 11.099 11.099 0 0 0 3.188 1.546c1.19.383 2.408.629 3.653.724a29.86 29.86 0 0 0 3.83.082.794.794 0 0 1 .822.766.795.795 0 0 1-.602.807c-1.355.328-2.75.52-4.16.561-1.436.041-2.859-.11-4.254-.424a12.753 12.753 0 0 1-4.105-1.71 8.834 8.834 0 0 1-3.133-3.515 1.468 1.468 0 0 1 .657-1.955 1.47 1.47 0 0 1 1.956.656l.041.028Z"
        fill="#1737AA"
      />
      <path
        d="M20.994 51.462c-7.019 0-12.724-5.484-12.724-12.213 0-6.73 5.705-12.214 12.724-12.214 7.018 0 12.724 5.485 12.724 12.214s-5.706 12.213-12.724 12.213Zm0-22.594c-6.02 0-10.904 4.664-10.904 10.394s4.898 10.395 10.904 10.395 10.904-4.664 10.904-10.395c0-5.73-4.898-10.394-10.904-10.394ZM54.337 48.932c-7.361 0-13.354-5.73-13.354-12.788 0-7.057 5.993-12.788 13.354-12.788 7.36 0 13.352 5.731 13.352 12.788 0 7.058-5.992 12.788-13.352 12.788Zm0-23.743c-6.362 0-11.534 4.924-11.534 10.955 0 6.032 5.172 10.955 11.534 10.955 6.361 0 11.533-4.923 11.533-10.955 0-6.031-5.172-10.955-11.534-10.955Z"
        fill="#FEE643"
      />
      <path
        d="M32.764 39.126a.905.905 0 0 1-.916-.903c0-.287.137-.56.37-.739.15-.109 3.652-2.653 9.918-.834a.905.905 0 0 1 .616 1.135.896.896 0 0 1-1.122.616c-5.35-1.546-8.209.465-8.318.547a.903.903 0 0 1-.548.178Z"
        fill="#FEE643"
      />
      <path
        d="M28.231 40.712a1.246 1.246 0 0 0-.191-.574 1.09 1.09 0 0 0 .123-.588 1.155 1.155 0 0 0-1.204-1.08c-.055 0-6.088.369-8.058.423-.63.014-1.122.52-1.109 1.15 0 .218.069.437.192.615-.082.15-.15.3-.192.465-.191.588.11 1.258 1.095 1.19.04 0 .096 0 .137.013 2.01-.054 7.88-.41 8.14-.424.616-.013 1.095-.56 1.067-1.19Z"
        fill="#1737AA"
      />
      <path
        d="M74.747 90.386c1.738.123 22.67-45.215 26.597-57.634a1.914 1.914 0 0 0-1.231-2.393 2.035 2.035 0 0 0-.698-.082c-5.787.342-11.492.3-16.992-.534a3.404 3.404 0 0 0-3.9 2.831c-.013.055-.013.11-.027.15-1.915 17.11-6.348 33.96-12.56 50.633l8.811 7.03Z"
        fill="url(#j)"
      />
      <path
        d="M61.176 36.322a1.134 1.134 0 0 0-1.15-1.49l-10.767.6c-.643.028-1.149.562-1.149 1.204v.15c.041.26 0 .52-.123.753a.744.744 0 0 0-.069.301c.028.588.288.985 1.068.957h.11l11.218-.601c.63-.041.93-.424 1.026-1.108a1.03 1.03 0 0 0-.164-.766Z"
        fill="#1737AA"
      />
      <path
        d="M82.497 107.209c-3.188 4.623-8.92 7.563-17.58 7.317-18.566-.519-23.054-43.3-19.51-50.139 2.107-4.048 4.733-.643 6.348 2.284.328.575 1.067.752 1.642.424a.836.836 0 0 0 .218-.164.954.954 0 0 1 .74-.191c2.667.328 1.696 2.83 5.075 6.66 0 0 3.024 4.007 3.448 3.747l.082-.082c.137-.246 0-.834-.328-1.819a21.59 21.59 0 0 1-.917-3.31c-.643-3.61.547-5.607 3.653-6.728 4.61-1.655 10.945 4.24 15.624 13.991a63.094 63.094 0 0 1 3.037 7.618c.124.37.233.739.342 1.122.233.78.425 1.572.589 2.352 1.313 6.319.629 12.419-2.463 16.918Z"
        fill="url(#k)"
      />
      <path
        d="M42.486 104.515c-4.652 12.145-21.138 17.738-29.265 10.12a13.07 13.07 0 0 1-.875-.875 17.452 17.452 0 0 1-3.694-6.346 23.759 23.759 0 0 1-1.136-5.594 38.172 38.172 0 0 1 .589-9.902c2.284-12.432 9.535-24.29 12.901-24.55 4.966-.383 5.65 4.951 6.718 10.805a2.5 2.5 0 0 0 .055.314c.123.712.26 1.423.424 2.148.082.478.26.944.506 1.367.574.835 1.313-.068 1.642-2.352.054-.356.095-.739.123-1.163.41-5.798 1.094-11.693 4.186-9.642a.358.358 0 0 1 .082.069 1.081 1.081 0 0 0 1.519.11c.137-.124.246-.274.301-.452.752-2.134 2.23-4.185 5.09-4.213 4.2 0 6.06 26.506.834 40.156Z"
        fill="url(#l)"
      />
      <path
        d="M42.36 58.52a3.173 3.173 0 0 1-.26.793c-.67 1.559-2.38 4.034-2.941 4.048-.944-.027-2.394-2.694-3.037-3.98-.206-.41-.329-.67-.329-.67-.342-.944-.451-1.86-.218-5.649.246-3.651 2.462-7.55 3.557-7.74a.333.333 0 0 1 .164 0c1.669.341 3.188 5.607 3.338 7.18v.205a39.398 39.398 0 0 1-.273 5.812Z"
        fill="#FEE643"
      />
      <path
        d="M42.366 58.52a3.173 3.173 0 0 1-.26.793c-.67 1.559-2.38 4.034-2.942 4.048-.342-2.776-.3-7.043-.793-8.397-.602-1.655.123-6.552.78-9.643a.333.333 0 0 1 .164 0c1.67.342 3.188 5.608 3.338 7.18v.206a41.35 41.35 0 0 1-.287 5.812Z"
        fill="#D6C14F"
      />
      <path
        d="M42.361 58.52a3.17 3.17 0 0 1-.26.793c-.643-.958-2.093-2.435-3.338-2.53-.698-.055-1.573 1.285-2.654 2.598-.89-1.504-.78-2.53-.534-6.319.876-.97 2.299-3.282 3.188-2.954 1.19.52 2.435 1.368 3.9 2.626.04 1.942.136 2.9-.302 5.786Z"
        fill="#1737AA"
      />
      <path
        d="M26.603 15.82c-6.69-4.65-8.879-7.576-8.879-14.428 0-1.163 1.505-.301 3.721 1.586-1.395-.711-2.435-1.067-2.517-.533-.123 8.083 4.556 10.162 7.675 13.376Z"
        fill="url(#m)"
      />
      <path
        d="M50.448-.756c.985-1.956.356-2.544-.15-2.544C40.31-1.03 35.986 14.767 35.59 16.217c1.546-7.878 5.39-19.216 16.02-20.98 1.355.93-.56 4.09-2.9 7.74.643-1.818 1.259-2.79 1.738-3.733Z"
        fill="url(#n)"
      />
      <path
        d="M27.798 78.515c-1.642 5.676-10.234 9.437-12.765 6.592-2.284 3.857-4.83 6.565-6.909 6.839a37.342 37.342 0 0 0-.588 9.874 23.73 23.73 0 0 0 1.135 5.608c3.366-.985 6.76-7.071 8.579-10.805 5.02 2.435 10.575-11.379 11.492-14.593l-.944-3.515ZM84.943 90.277c-1.998 0-5.254-.916-8.47-3.159-1.518 1.422-5.17 1.614-13.53-10.025.137-.246-.493-1.942-.712-3.064 2.436 1.792 8.4 4.185 10.22 1.888 4.05 4.116 6.184 3.898 8.524 3.337a62.28 62.28 0 0 1 3.05 7.618c.124.37.233.738.343 1.121.219.739.41 1.505.575 2.284Z"
        fill="#A8C4F9"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1="37.232"
        y1="72.671"
        x2="60.158"
        y2="114.29"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#1E5BF6" />
        <stop offset=".41" stopColor="#1D59F3" />
        <stop offset=".68" stopColor="#1B54EB" />
        <stop offset=".91" stopColor="#174ADC" />
        <stop offset="1" stopColor="#1545D3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="31.462"
        y1="-14.105"
        x2="43.126"
        y2="33.477"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#5F88F1" />
        <stop offset=".3" stopColor="#5C86F1" />
        <stop offset=".5" stopColor="#5380F2" />
        <stop offset=".68" stopColor="#4475F3" />
        <stop offset=".84" stopColor="#2F66F5" />
        <stop offset=".93" stopColor="#1E5AF6" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="84.488"
        y1="108.817"
        x2="46.674"
        y2="67.855"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#1E5BF6" />
        <stop offset=".41" stopColor="#1D59F3" />
        <stop offset=".68" stopColor="#1B54EB" />
        <stop offset=".91" stopColor="#174ADC" />
        <stop offset="1" stopColor="#1545D3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1="35.225"
        y1="45.504"
        x2="75.672"
        y2="45.504"
        gradientUnits="userSpaceOnUse">
        <stop offset=".05" stopColor="#4675F3" />
        <stop offset=".21" stopColor="#3465EE" />
        <stop offset=".33" stopColor="#2C5DEC" />
        <stop offset="1" stopColor="#2049CB" />
      </linearGradient>
      <linearGradient
        id="f"
        x1="30.437"
        y1="12.809"
        x2="57.937"
        y2="82.253"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#5F88F1" />
        <stop offset=".07" stopColor="#4F7CF2" />
        <stop offset=".2" stopColor="#396DF4" />
        <stop offset=".34" stopColor="#2A62F5" />
        <stop offset=".51" stopColor="#215CF6" />
        <stop offset=".75" stopColor="#1E5AF6" />
      </linearGradient>
      <linearGradient
        id="g"
        x1="15.774"
        y1="19.545"
        x2="28.386"
        y2="29.842"
        gradientUnits="userSpaceOnUse">
        <stop offset=".01" stopColor="#D4E3FA" />
        <stop offset=".56" stopColor="#D4E3FA" />
        <stop offset=".61" stopColor="#BFD3F8" />
        <stop offset=".7" stopColor="#96B3F5" />
        <stop offset=".79" stopColor="#789BF3" />
        <stop offset=".87" stopColor="#668DF2" />
        <stop offset=".92" stopColor="#5F88F1" />
      </linearGradient>
      <linearGradient
        id="h"
        x1="24.291"
        y1="40.333"
        x2="23.047"
        y2="77.314"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#D1E3FE" />
        <stop offset=".18" stopColor="#CEE0FE" />
        <stop offset=".33" stopColor="#C3D8FD" />
        <stop offset=".47" stopColor="#B1CBFD" />
        <stop offset=".6" stopColor="#99B8FB" />
        <stop offset=".73" stopColor="#79A0FA" />
        <stop offset=".86" stopColor="#5182F8" />
        <stop offset=".99" stopColor="#245FF6" />
        <stop offset="1" stopColor="#1E5BF6" />
      </linearGradient>
      <linearGradient
        id="i"
        x1="56.274"
        y1="41.407"
        x2="52.05"
        y2="85.189"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#D1E3FE" />
        <stop offset=".14" stopColor="#CDE0FE" />
        <stop offset=".29" stopColor="#C0D6FD" />
        <stop offset=".44" stopColor="#AAC5FC" />
        <stop offset=".6" stopColor="#8BAEFB" />
        <stop offset=".77" stopColor="#6490F9" />
        <stop offset=".93" stopColor="#356DF7" />
        <stop offset="1" stopColor="#1E5BF6" />
      </linearGradient>
      <linearGradient
        id="j"
        x1="90.126"
        y1="33.608"
        x2="65.718"
        y2="86.361"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#1E5AF6" />
        <stop offset=".07" stopColor="#1B51E6" />
        <stop offset=".24" stopColor="#1441C6" />
        <stop offset=".41" stopColor="#0F34AD" />
        <stop offset=".59" stopColor="#0C2A9C" />
        <stop offset=".78" stopColor="#0A2591" />
        <stop offset="1" stopColor="#09238E" />
      </linearGradient>
      <linearGradient
        id="k"
        x1="64.518"
        y1="110.821"
        x2="65.657"
        y2="39.376"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#5587F9" />
        <stop offset=".3" stopColor="#5285F9" />
        <stop offset=".48" stopColor="#4A7EF8" />
        <stop offset=".64" stopColor="#3B72F8" />
        <stop offset=".78" stopColor="#2661F6" />
        <stop offset=".83" stopColor="#1E5AF6" />
      </linearGradient>
      <linearGradient
        id="l"
        x1="46.525"
        y1="109.923"
        x2="5.426"
        y2="65.4"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#5587F9" />
        <stop offset=".47" stopColor="#5385F9" />
        <stop offset=".64" stopColor="#4C80F9" />
        <stop offset=".76" stopColor="#4176F8" />
        <stop offset=".85" stopColor="#3069F7" />
        <stop offset=".92" stopColor="#1E5AF6" />
      </linearGradient>
      <linearGradient
        id="m"
        x1="14.911"
        y1="2.069"
        x2="28.367"
        y2="13.059"
        gradientUnits="userSpaceOnUse">
        <stop offset=".01" stopColor="#D4E3FA" />
        <stop offset=".56" stopColor="#D4E3FA" />
        <stop offset=".61" stopColor="#BFD3F8" />
        <stop offset=".7" stopColor="#96B3F5" />
        <stop offset=".79" stopColor="#789BF3" />
        <stop offset=".87" stopColor="#668DF2" />
        <stop offset=".92" stopColor="#5F88F1" />
      </linearGradient>
      <linearGradient
        id="n"
        x1="43.507"
        y1="-.767"
        x2="44.077"
        y2="11.707"
        gradientUnits="userSpaceOnUse">
        <stop offset=".01" stopColor="#D4E3FA" />
        <stop offset=".56" stopColor="#D4E3FA" />
        <stop offset=".63" stopColor="#CFDFFA" />
        <stop offset=".72" stopColor="#C0D4F8" />
        <stop offset=".81" stopColor="#A8C1F7" />
        <stop offset=".91" stopColor="#86A7F4" />
        <stop offset="1" stopColor="#5F88F1" />
      </linearGradient>
      <clipPath id="a">
        <path
          fill="#fff"
          transform="translate(0 .184)"
          d="M0 0h112.553v87.816H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export { CocoSad };
